import { render, staticRenderFns } from "./foreignStateLogin.vue?vue&type=template&id=2798d0c3&scoped=true&"
import script from "./foreignStateLogin.vue?vue&type=script&lang=js&"
export * from "./foreignStateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2798d0c3",
  null
  
)

export default component.exports